var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "-2 -2 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M13.333 5v6.667c0 .92-.746 1.666-1.666 1.666H5m30 0h-6.667c-.92 0-1.666-.746-1.666-1.666V5m0 30v-6.667c0-.92.746-1.666 1.666-1.666H35m-30 0h6.667c.92 0 1.666.746 1.666 1.666V35"
  })));
};
export default SvgExitFullscreen;